import { render } from "./dashboardComponent.vue?vue&type=template&id=a4f696de"
import script from "./dashboardComponent.vue?vue&type=script&lang=js"
export * from "./dashboardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__